import { useQuery, UseQueryResult } from '@tanstack/react-query';
import API from 'lib/api';
import type { IVicinityMapData } from 'lib/models/vicinityMap.interface';

// VICINITY MAP
export const useVicinityMapQuery = (params?: {
  communityId: string | null;
}): UseQueryResult<IVicinityMapData, Error> => {
  return useQuery(['getVicinityMap'], () => API.get('/vm', { params: params! }), {
    enabled: !!params?.communityId,
  });
};
